import ZigWheelBase, { createRandom } from './ZigWheelBase';
import { BoardID } from 'BoardID';
import { sumPattern } from 'Pattern';
import {
  BoardType,
  Dimensions2D,
  Direction,
  Material,
  Renderable,
  TwoArray,
  Units,
  ZigZagParams,
} from 'Types';

import { fillRenderablesAt } from 'utils/utils';

export default class ZigZag extends ZigWheelBase<BoardType.ZigZag> {
  constructor(id: BoardID, name: string, params: ZigZagParams, units?: Units) {
    super(BoardType.ZigZag, id, name, params, units);
  }

  static createRandom(
    materials: TwoArray<Material>,
    size: Dimensions2D
  ): ZigZagParams {
    return createRandom<BoardType.ZigZag>(materials, size);
  }

  getRenderables(): Array<Renderable<BoardType.ZigZag>> {
    const { numHorizontal, numVertical } = this.params;
    const pattern = this.getPattern();
    const patternSize = sumPattern(pattern);

    const renderables: Array<Renderable<BoardType.ZigZag>> = [];

    let topOffset = 0;
    let leftOffset = 0;

    for (let rowIndex = 0; rowIndex < numVertical; ++rowIndex) {
      for (let colIndex = 0; colIndex < numHorizontal; ++colIndex) {
        topOffset = rowIndex * patternSize;
        leftOffset = colIndex * patternSize;

        const direction =
          (rowIndex % 2 === 0 && colIndex % 2 === 0) ||
          (rowIndex % 2 === 1 && colIndex % 2 === 1)
            ? Direction.H
            : Direction.V;

        fillRenderablesAt(
          renderables,
          pattern,
          topOffset,
          leftOffset,
          patternSize,
          direction,
          ({ fragmentIndex, renderableIndex }) => ({
            type: BoardType.ZigZag,
            fragmentIndex,
            rowIndex,
            colIndex,
            renderableIndex,
          })
        );
      }
    }

    return renderables;
  }
}
